const ErrorFallback = () => (
  <div className="p-10 text-center">
    <h2 className="text-2xl font-bold text-red-600">Oops! Something went wrong.</h2>
    <p>Please try refreshing the page or contact support.</p>
  </div>
);

export default ErrorFallback;